import React, { useState } from "react";
import pdfIcon from "../../assets/pdfIcon.svg";
import xlsIcon from "../../assets/xlsIcon.svg";
import csvIcon from "../../assets/csvIcon.svg";
import Overlay from "./Overlay";
import scanAndAutoFill from "../BuyerDashboard/Management/ScanAndAutofill";

const DragAndDropComponent = ({
  onPreview,
  onDelete,
  importedFiles,
  setImportedFiles,
  setMissingFileError,
  setPdfFile,
  setAutoFilledData,
  subtitle,
  width,
  margin,
  height,
  color,
  documentIcon,
  background,
  rfp,
  eyeIconWhite,
  trashIcon,
  error,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleFileChange = async (event) => {
    event.preventDefault();
    const selectedFiles = event.target.files || event.dataTransfer.files;

    if (selectedFiles) {
      // onFileChange(selectedFiles);
      const newFiles = Array.from(selectedFiles);
      setImportedFiles((prevFiles) => [...prevFiles, ...newFiles]);

      const file = selectedFiles[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = e.target.result;
        setPdfFile(fileData);
      };
      try {
        const autoFillData = await scanAndAutoFill(file);
        setAutoFilledData(autoFillData);
      } catch (error) {
        console.error("Error scanning and auto-filling:", error);
      }

      reader.readAsDataURL(file);
    }
  };
    const handleRfpFileChange = async (event) => {
    event.preventDefault();
    const selectedFiles = event.target.files || event.dataTransfer.files;

    if (selectedFiles) {
      setMissingFileError(false);
      const newFiles = Array.from(selectedFiles);
      setImportedFiles((prevFiles) => [...prevFiles, ...newFiles]);

      const file = selectedFiles[0];
        setPdfFile(file);
      };
  };

  const handleDeleteClick = (file) => {
    setFileToDelete(file);
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    if (fileToDelete) {
      onDelete(fileToDelete.name);
      setFileToDelete(null);
      setShowConfirmation(false);
    }
  };

  const handleCancelDelete = () => {
    setFileToDelete(null);
    setShowConfirmation(false);
  };

  const getFileIcon = (fileName) => {
    const fileExtension = fileName.split(".").pop().toLowerCase();
    const iconMappings = {
      pdf: pdfIcon,
      xls: xlsIcon,
      csv: csvIcon,
    };
    return iconMappings[fileExtension];
  };

  return (
    <>
      <div
        className="flex justify-center"
        onDragOver={handleDragOver}
        onDrop={rfp ? handleRfpFileChange :handleFileChange}
      >
        <input
          type="file"
          id="fileInput"
          className="hidden"
          onChange={rfp ? handleRfpFileChange :handleFileChange}
          multiple
        />
        <label
          htmlFor="fileInput"
          className={`flex flex-col items-center justify-center border ${
            error ? "border-red-500" : "border-[#7A7A7A]"
          } border-dashed p-5 text-center mb-5 bg-[#FBFBFB]`}
          style={{
            width: width || "562px",
            marginTop: margin || "",
            height: height || "194px",
            background: background || "",
          }}
        >
          <svg
            className="mb-[22px]"
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            viewBox="0 0 57 57"
            fill="none"
          >
            <path
              d="M54.625 42.75H47.5V35.625H42.75V42.75H35.625V47.5H42.75V54.625H47.5V47.5H54.625M14.25 4.75C12.9902 4.75 11.782 5.25044 10.8912 6.14124C10.0004 7.03204 9.5 8.24022 9.5 9.5V47.5C9.5 50.1363 11.6137 52.25 14.25 52.25H32.7988C31.9438 50.7775 31.35 49.1625 31.065 47.5H14.25V9.5H30.875V21.375H42.75V31.065C43.5338 30.9462 44.3412 30.875 45.125 30.875C45.9325 30.875 46.7162 30.9462 47.5 31.065V19L33.25 4.75M19 28.5V33.25H38V28.5M19 38V42.75H30.875V38H19Z"
              fill="#DCDCDC"
            />
          </svg>
          <p className="text-sm" style={{ color: color || "#8F8F8F" }}>
            Drag and drop files here or{" "}
            <strong className="font-bold" style={{ color: color || "#08F" }}>
              browse
            </strong>
          </p>
          <p className="text-[10px]" style={{ color: color || "#8F8F8F" }}>
            File must be in {subtitle || "PDF"} and less than 20mb
          </p>
        </label>
      </div>

      {error && (
        <p className="text-red-500 mt-2">
          An error occurred. Please upload a valid file.
        </p>
      )}

      <div className="mt-5">
        {!error &&
          importedFiles.length > 0 &&
          importedFiles.map((file, index) => {
            const fileSize = Math.round(file.size / 1024);
            const fileIcon = getFileIcon(file.name);
            const fileType = file.name.split(".").pop().toLowerCase();
            const filePreviewUrl = URL.createObjectURL(file);

            return (
              <div
                key={index}
                className="flex justify-between items-center py-2"
              >
                <div className="flex">
                  {["jpg", "jpeg", "png", "gif"].includes(fileType) ? (
                    <img
                      src={filePreviewUrl}
                      alt={file.name}
                      className="w-[50px] h-[50px] object-cover rounded-lg bg-[#EDEDED] mr-2 p-3"
                    />
                  ) : (
                    <img
                      src={fileIcon}
                      alt=""
                      className="rounded-lg bg-[#EDEDED] mr-2 p-3 "
                    />
                  )}
                  <div className="flex flex-col items-start">
                    <span style={{ color: color || "#000000" }} className="text-sm text-left">
                      {file.name}
                    </span>
                    <span
                      className="text-xs"
                      style={{ color: color || "#8F8F8F" }}
                    >
                      {fileSize}kb
                    </span>
                  </div>
                </div>
                <div className="flex gap-[21px]">
                  {fileType === "pdf" && (
                    <svg
                      onClick={() => onPreview(file)}
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_180_60729)">
                        <path
                          d="M12.5 4C15.287 4 17.763 5.257 19.526 6.813C20.411 7.594 21.14 8.471 21.654 9.344C22.159 10.201 22.5 11.13 22.5 12C22.5 12.87 22.16 13.799 21.654 14.656C21.14 15.529 20.411 16.406 19.526 17.187C17.763 18.743 15.286 20 12.5 20C9.713 20 7.237 18.743 5.474 17.187C4.589 16.406 3.86 15.529 3.346 14.656C2.84 13.799 2.5 12.87 2.5 12C2.5 11.13 2.84 10.201 3.346 9.344C3.86 8.471 4.589 7.594 5.474 6.813C7.237 5.257 9.714 4 12.5 4ZM12.5 6C10.316 6 8.292 6.993 6.798 8.312C6.054 8.968 5.466 9.685 5.069 10.359C4.663 11.049 4.5 11.62 4.5 12C4.5 12.38 4.663 12.951 5.069 13.641C5.466 14.315 6.054 15.031 6.798 15.688C8.292 17.007 10.316 18 12.5 18C14.684 18 16.708 17.007 18.202 15.688C18.946 15.031 19.534 14.315 19.931 13.641C20.337 12.951 20.5 12.38 20.5 12C20.5 11.62 20.337 11.049 19.931 10.359C19.534 9.685 18.946 8.969 18.202 8.312C16.708 6.993 14.684 6 12.5 6ZM12.5 9C12.588 9 12.675 9.004 12.761 9.011C12.5439 9.39185 12.4579 9.8335 12.5163 10.268C12.5747 10.7025 12.7743 11.1057 13.0843 11.4157C13.3943 11.7257 13.7975 11.9253 14.232 11.9837C14.6665 12.0421 15.1081 11.9561 15.489 11.739C15.5416 12.3412 15.411 12.9452 15.1145 13.4719C14.8179 13.9986 14.3692 14.4234 13.827 14.6907C13.2849 14.958 12.6746 15.0553 12.0762 14.9699C11.4778 14.8844 10.9192 14.6202 10.4736 14.2118C10.0279 13.8034 9.71603 13.27 9.57876 12.6813C9.44149 12.0926 9.48524 11.4762 9.70429 10.9128C9.92334 10.3495 10.3075 9.8654 10.8063 9.52407C11.3052 9.18275 11.8955 9.00008 12.5 9Z"
                          fill="#7B7B7B"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_180_60729">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="translate(0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  )}
                  <svg
                    onClick={() => handleDeleteClick(file)}
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M10.5 6H14.5C14.5 5.46957 14.2893 4.96086 13.9142 4.58579C13.5391 4.21071 13.0304 4 12.5 4C11.9696 4 11.4609 4.21071 11.0858 4.58579C10.7107 4.96086 10.5 5.46957 10.5 6ZM8.5 6C8.5 4.93913 8.92143 3.92172 9.67157 3.17157C10.4217 2.42143 11.4391 2 12.5 2C13.5609 2 14.5783 2.42143 15.3284 3.17157C16.0786 3.92172 16.5 4.93913 16.5 6H21.5C21.7652 6 22.0196 6.10536 22.2071 6.29289C22.3946 6.48043 22.5 6.73478 22.5 7C22.5 7.26522 22.3946 7.51957 22.2071 7.70711C22.0196 7.89464 21.7652 8 21.5 8H20.618L19.732 18.34C19.6468 19.3385 19.19 20.2686 18.4519 20.9463C17.7137 21.6241 16.7481 22.0001 15.746 22H9.254C8.25191 22.0001 7.28628 21.6241 6.54815 20.9463C5.81002 20.2686 5.35318 19.3385 5.268 18.34L4.382 8H3.5C3.23478 8 2.98043 7.89464 2.79289 7.70711C2.60536 7.51957 2.5 7.26522 2.5 7C2.5 6.73478 2.60536 6.48043 2.79289 6.29289C2.98043 6.10536 3.23478 6 3.5 6H8.5ZM15.5 12C15.5 11.7348 15.3946 11.4804 15.2071 11.2929C15.0196 11.1054 14.7652 11 14.5 11C14.2348 11 13.9804 11.1054 13.7929 11.2929C13.6054 11.4804 13.5 11.7348 13.5 12V16C13.5 16.2652 13.6054 16.5196 13.7929 16.7071C13.9804 16.8946 14.2348 17 14.5 17C14.7652 17 15.0196 16.8946 15.2071 16.7071C15.3946 16.5196 15.5 16.2652 15.5 16V12ZM10.5 11C10.7652 11 11.0196 11.1054 11.2071 11.2929C11.3946 11.4804 11.5 11.7348 11.5 12V16C11.5 16.2652 11.3946 16.5196 11.2071 16.7071C11.0196 16.8946 10.7652 17 10.5 17C10.2348 17 9.98043 16.8946 9.79289 16.7071C9.60536 16.5196 9.5 16.2652 9.5 16V12C9.5 11.7348 9.60536 11.4804 9.79289 11.2929C9.98043 11.1054 10.2348 11 10.5 11ZM7.26 18.17C7.3026 18.6694 7.53117 19.1346 7.90044 19.4735C8.26972 19.8124 8.75278 20.0003 9.254 20H15.746C16.2469 19.9998 16.7294 19.8117 17.0983 19.4728C17.4671 19.134 17.6954 18.6691 17.738 18.17L18.61 8H6.39L7.26 18.17Z"
                      fill="#7B7B7B"
                    />
                  </svg>
                </div>
              </div>
            );
          })}
      </div>

      {showConfirmation && (
        <>
          <Overlay />
          <div className="fixed top-1/2 left-1/2 z-[1000] flex items-center justify-center transform -translate-x-1/2 -translate-y-1/2">
            <div className="flex flex-col bg-white w-[521px] h-[242px] rounded-lg px-[72px] pt-[66px] pb-[30px]">
              <svg
                className="mb-7 ml-[10px] rounded-full p-[5px]"
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  d="M10.5 6H14.5C14.5 5.46957 14.2893 4.96086 13.9142 4.58579C13.5391 4.21071 13.0304 4 12.5 4C11.9696 4 11.4609 4.21071 11.0858 4.58579C10.7107 4.96086 10.5 5.46957 10.5 6ZM8.5 6C8.5 4.93913 8.92143 3.92172 9.67157 3.17157C10.4217 2.42143 11.4391 2 12.5 2C13.5609 2 14.5783 2.42143 15.3284 3.17157C16.0786 3.92172 16.5 4.93913 16.5 6H21.5C21.7652 6 22.0196 6.10536 22.2071 6.29289C22.3946 6.48043 22.5 6.73478 22.5 7C22.5 7.26522 22.3946 7.51957 22.2071 7.70711C22.0196 7.89464 21.7652 8 21.5 8H20.618L19.732 18.34C19.6468 19.3385 19.19 20.2686 18.4519 20.9463C17.7137 21.6241 16.7481 22.0001 15.746 22H9.254C8.25191 22.0001 7.28628 21.6241 6.54815 20.9463C5.81002 20.2686 5.35318 19.3385 5.268 18.34L4.382 8H3.5C3.23478 8 2.98043 7.89464 2.79289 7.70711C2.60536 7.51957 2.5 7.26522 2.5 7C2.5 6.73478 2.60536 6.48043 2.79289 6.29289C2.98043 6.10536 3.23478 6 3.5 6H8.5ZM15.5 12C15.5 11.7348 15.3946 11.4804 15.2071 11.2929C15.0196 11.1054 14.7652 11 14.5 11C14.2348 11 13.9804 11.1054 13.7929 11.2929C13.6054 11.4804 13.5 11.7348 13.5 12V16C13.5 16.2652 13.6054 16.5196 13.7929 16.7071C13.9804 16.8946 14.2348 17 14.5 17C14.7652 17 15.0196 16.8946 15.2071 16.7071C15.3946 16.5196 15.5 16.2652 15.5 16V12ZM10.5 11C10.7652 11 11.0196 11.1054 11.2071 11.2929C11.3946 11.4804 11.5 11.7348 11.5 12V16C11.5 16.2652 11.3946 16.5196 11.2071 16.7071C11.0196 16.8946 10.7652 17 10.5 17C10.2348 17 9.98043 16.8946 9.79289 16.7071C9.60536 16.5196 9.5 16.2652 9.5 16V12C9.5 11.7348 9.60536 11.4804 9.79289 11.2929C9.98043 11.1054 10.2348 11 10.5 11ZM7.26 18.17C7.3026 18.6694 7.53117 19.1346 7.90044 19.4735C8.26972 19.8124 8.75278 20.0003 9.254 20H15.746C16.2469 19.9998 16.7294 19.8117 17.0983 19.4728C17.4671 19.134 17.6954 18.6691 17.738 18.17L18.61 8H6.39L7.26 18.17Z"
                  fill="#7B7B7B"
                />
              </svg>
              {/* You can add text/buttons here for the confirmation prompt */}
              <p className="text-center mb-4">
                Are you sure you want to delete this file?
              </p>
              <div className="flex justify-center gap-4 mt-auto">
                <button
                  className="bg-red-500 text-white px-4 py-2 rounded"
                  onClick={handleConfirmDelete}
                >
                  Delete
                </button>
                <button
                  className="bg-gray-300 text-black px-4 py-2 rounded"
                  onClick={handleCancelDelete}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DragAndDropComponent;
